const portRegion = {
    _id: undefined,
    name: undefined,
};

export const order = {
    vesselName: undefined,
    vesselId: undefined,
    hire: undefined,
    hireType: undefined,
    delivery: Object.assign({}, portRegion),
    redelivery: Object.assign({}, portRegion),
    mainRegionDelivery: Object.assign({}, portRegion),
    mainRegionRedelivery: Object.assign({}, portRegion),
    lay: new Date(new Date().setHours(0, 0, 0, 0)),
    can: new Date(new Date().setHours(23, 59, 59, 999)),
    duration: undefined,
    cargoId: undefined,
    cargo: {
        _id: undefined,
        name: undefined,
        // parent: {
        //     red: {
        //         _id: undefined,
        //         name: undefined,
        //     },
        // },
    },
    cargoRegionId: undefined,
    cargoRegion: {
        _id: undefined,
        name: undefined,
    },
    vesselData: {},
};

/**
 * @typedef {'hireIdea' | 'fixedRate' | 'offerRate'} HireType
 */

/**
 * @typedef {Object} Cargo
 * @property {string | undefined} _id
 * @property {string | undefined} name
 */

/**
 * @typedef {Object} CargoRegion
 * @property {string | undefined} _id
 * @property {string | undefined} name
 */

/**
 * @typedef {Object} DelRedel
 * @property {string | undefined} _id
 * @property {string | undefined} name
 */

/**
 * @typedef {Object} HireOrderRaw
 * @property {string | undefined} vesselName
 * @property {string | undefined} vesselId
 * @property {string | undefined} hire
 * @property {HireType | undefined} hireType
 * @property {DelRedel} delivery
 * @property {DelRedel} redelivery
 * @property {Date | undefined} mainRegionDelivery
 * @property {Date | undefined} mainRegionRedelivery
 * @property {string | undefined} duration
 * @property {string | undefined} cargoId
 * @property {Cargo} cargo
 * @property {CargoRegion} cargoRegion
 * @property {string | undefined} cargoRegionId
 * @property {{ _id: string, name: string }} vesselData
 */

/**
 * @typedef {Object} HireOrder
 * @property {string} vesselId
 * @property {number} hire
 * @property {HireType} hireType
 * @property {string} delivery
 * @property {string} redelivery
 * @property {string} [duration]
 * @property {string} [cargoId]
 * @property {string} [cargoRegionId]
 */



// WEBPACK FOOTER //
// ./app/mocks/hire/order.js